// Labels are needed during GA events
export const PAYMENT_TYPE_2_TRANSLATION_KEY = {
  account: "checkoutPage.payment.account",
  "card-jp": "checkoutPage.creditCard.creditCardLabel",
  "Sales Partner Order": "checkoutPage.salesPartner.salesPartnerLabel",
};
